import { FC, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { AppDispatch, RootState } from 'redux/store'
import { clearAllFilters } from 'redux/ui/ledgerUI'
import { useGET_ledgerQuery } from 'redux/api/ledgerApi'

import MainTable from 'components/organisms/tables/MainTable'

import { useTableModel } from 'utils/tableModels/useLedgerTableModel'

interface IProps {
  studentProfileId: number
}

const StudentLedger: FC<IProps> = ({ studentProfileId }) => {
  const dispatch = useDispatch<AppDispatch>()
  const reduxKey = 'ledger'

  const search = useSelector((state: RootState) => state[reduxKey].tableFilters.search)
  // Stable reference: MainTable resets to page 1 whenever the filters object changes
  const filters = useMemo(() => ({ search, student_id: studentProfileId }), [search, studentProfileId])

  useEffect(() => {
    dispatch(clearAllFilters())
  }, [])

  return (
    <MainTable
      useTableModel={useTableModel}
      getTableData={useGET_ledgerQuery}
      filters={filters}
    />
  )
}
export default StudentLedger
